import classNames from 'classnames'
import React from 'react'
import { StockoLogo } from 'src/components/framework/icons/logo'
import { Button, Fill } from 'src/components/framework/ui'
import { Search } from 'src/components/page/layout/header/search'

import * as styles from './header.module.scss'

export const Header: React.FC = () => (
  <header className={styles.header}>
    <div className={styles.header__left}>
      <a href="/" className={styles.header__logo} aria-label="Go to home page">
        <StockoLogo />
      </a>
      <Search className={styles.header__search} />
    </div>

    <div className={classNames(styles.header__right, 'stk-buttons-wrapper')}>
      <Button href="/auth/login">Login</Button>
      <Button href="/auth/register" primary variant="success">
        Get Started
      </Button>
    </div>
  </header>
)
